"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSelectedVariant = exports.updateSelectedRelationshipProduct = exports.updateSelectedPlan = exports.updateSelectedHandset = exports.updateSelectedBusinessSolution = exports.updateSelectedBroadband = exports.unsetRecommendation = exports.showPlanRecommendation = exports.setRecommendationTags = exports.setRecommendationSteps = exports.setRecommendationStep = exports.setRecommendation = exports.setRawRecommendation = exports.setRating = exports.setPricesCosts = exports.setIsAddonSelected = exports.setAreRecommendationSpecsVisible = exports.setAdditionalPlans = exports.saveRating = exports.reopenRecommendation = exports.goToUpsellPage = exports.goToPreviousStep = exports.goToNextStep = exports.goToComparisonPage = exports.goBackToQuestionnaire = exports.goBackToCurrentQuestion = exports.fetchRecommendation = exports.clearRating = exports.UPDATE_SELECTED_VARIANT = exports.UPDATE_SELECTED_RELATIONSHIP_PRODUCT = exports.UPDATE_SELECTED_PLAN = exports.UPDATE_SELECTED_HANDSET = exports.UPDATE_SELECTED_BUSINESS_SOLUTION = exports.UPDATE_SELECTED_BROADBAND = exports.UNSET_RECOMMENDATION = exports.SHOW_PLAN_RECOMMENDATION = exports.SET_STEPS = exports.SET_STEP = exports.SET_RECOMMENDATION_TAGS = exports.SET_RECOMMENDATION = exports.SET_RAW_RECOMMENDATION = exports.SET_RATING = exports.SET_PRICES_COSTS = exports.SET_IS_ADDON_SELECTED = exports.SET_ARE_RECOMMENDATION_SPECS_VISIBLE = exports.SET_ADDITIONAL_PLANS = exports.SAVE_RATING = exports.REOPEN_RECOMMENDATION = exports.GO_TO_UPSELL_PAGE = exports.GO_TO_PREVIOUS_STEP = exports.GO_TO_NEXT_STEP = exports.GO_TO_COMPARISON_PAGE = exports.GO_BACK_TO_QUESTIONNAIRE = exports.GO_BACK_TO_CURRENT_QUESTION = exports.FETCH_RECOMMENDATION_SUCCESS = exports.FETCH_RECOMMENDATION = exports.CLEAR_RATING = void 0;
const FETCH_RECOMMENDATION = 'FETCH_RECOMMENDATION';
exports.FETCH_RECOMMENDATION = FETCH_RECOMMENDATION;
const FETCH_RECOMMENDATION_SUCCESS = 'FETCH_RECOMMENDATION_SUCCESS';
exports.FETCH_RECOMMENDATION_SUCCESS = FETCH_RECOMMENDATION_SUCCESS;
const SET_RECOMMENDATION = 'SET_RECOMMENDATION';
exports.SET_RECOMMENDATION = SET_RECOMMENDATION;
const SET_RAW_RECOMMENDATION = 'SET_RAW_RECOMMENDATION';
exports.SET_RAW_RECOMMENDATION = SET_RAW_RECOMMENDATION;
const UNSET_RECOMMENDATION = 'UNSET_RECOMMENDATION';
exports.UNSET_RECOMMENDATION = UNSET_RECOMMENDATION;
const GO_BACK_TO_QUESTIONNAIRE = 'GO_BACK_TO_QUESTIONNAIRE';
exports.GO_BACK_TO_QUESTIONNAIRE = GO_BACK_TO_QUESTIONNAIRE;
const GO_BACK_TO_CURRENT_QUESTION = 'GO_BACK_TO_CURRENT_QUESTION';
exports.GO_BACK_TO_CURRENT_QUESTION = GO_BACK_TO_CURRENT_QUESTION;
const GO_TO_UPSELL_PAGE = 'GO_TO_UPSELL_PAGE';
exports.GO_TO_UPSELL_PAGE = GO_TO_UPSELL_PAGE;
const GO_TO_COMPARISON_PAGE = 'GO_TO_COMPARISON_PAGE';
exports.GO_TO_COMPARISON_PAGE = GO_TO_COMPARISON_PAGE;
const UPDATE_SELECTED_HANDSET = 'UPDATE_SELECTED_HANDSET';
exports.UPDATE_SELECTED_HANDSET = UPDATE_SELECTED_HANDSET;
const UPDATE_SELECTED_PLAN = 'UPDATE_SELECTED_PLAN';
exports.UPDATE_SELECTED_PLAN = UPDATE_SELECTED_PLAN;
const UPDATE_SELECTED_BROADBAND = 'UPDATE_SELECTED_BROADBAND';
exports.UPDATE_SELECTED_BROADBAND = UPDATE_SELECTED_BROADBAND;
const UPDATE_SELECTED_BUSINESS_SOLUTION = 'UPDATE_SELECTED_BUSINESS_SOLUTION';
exports.UPDATE_SELECTED_BUSINESS_SOLUTION = UPDATE_SELECTED_BUSINESS_SOLUTION;
const UPDATE_SELECTED_VARIANT = 'UPDATE_SELECTED_VARIANT';
exports.UPDATE_SELECTED_VARIANT = UPDATE_SELECTED_VARIANT;
const UPDATE_SELECTED_RELATIONSHIP_PRODUCT = 'UPDATE_SELECTED_RELATIONSHIP_PRODUCT';
exports.UPDATE_SELECTED_RELATIONSHIP_PRODUCT = UPDATE_SELECTED_RELATIONSHIP_PRODUCT;
const SET_STEPS = 'SET_STEPS';
exports.SET_STEPS = SET_STEPS;
const SET_STEP = 'SET_STEP';
exports.SET_STEP = SET_STEP;
const GO_TO_NEXT_STEP = 'GO_TO_NEXT_STEP';
exports.GO_TO_NEXT_STEP = GO_TO_NEXT_STEP;
const GO_TO_PREVIOUS_STEP = 'GO_TO_PREVIOUS_STEP';
exports.GO_TO_PREVIOUS_STEP = GO_TO_PREVIOUS_STEP;
const SET_ADDITIONAL_PLANS = 'SET_ADDITIONAL_PLANS';
exports.SET_ADDITIONAL_PLANS = SET_ADDITIONAL_PLANS;
const SET_PRICES_COSTS = 'SET_PRICES_COSTS';
exports.SET_PRICES_COSTS = SET_PRICES_COSTS;
const SET_RECOMMENDATION_TAGS = 'SET_RECOMMENDATION_TAGS';
exports.SET_RECOMMENDATION_TAGS = SET_RECOMMENDATION_TAGS;
const SET_ARE_RECOMMENDATION_SPECS_VISIBLE = 'SET_ARE_RECOMMENDATION_SPECS_VISIBLE';
exports.SET_ARE_RECOMMENDATION_SPECS_VISIBLE = SET_ARE_RECOMMENDATION_SPECS_VISIBLE;
const REOPEN_RECOMMENDATION = 'REOPEN_RECOMMENDATION';
exports.REOPEN_RECOMMENDATION = REOPEN_RECOMMENDATION;
const SHOW_PLAN_RECOMMENDATION = 'SHOW_PLAN_RECOMMENDATION';
exports.SHOW_PLAN_RECOMMENDATION = SHOW_PLAN_RECOMMENDATION;
const SET_IS_ADDON_SELECTED = 'SET_IS_ADDON_SELECTED';
exports.SET_IS_ADDON_SELECTED = SET_IS_ADDON_SELECTED;
const SET_RATING = 'SET_RATING';
exports.SET_RATING = SET_RATING;
const SAVE_RATING = 'SAVE_RATING';
exports.SAVE_RATING = SAVE_RATING;
const CLEAR_RATING = 'CLEAR_RATING';
exports.CLEAR_RATING = CLEAR_RATING;
const fetchRecommendation = () => ({
  type: FETCH_RECOMMENDATION
});
exports.fetchRecommendation = fetchRecommendation;
const setRawRecommendation = recommendationResponse => ({
  type: SET_RAW_RECOMMENDATION,
  payload: {
    recommendationResponse
  }
});
exports.setRawRecommendation = setRawRecommendation;
const setRecommendation = recommendationData => ({
  type: SET_RECOMMENDATION,
  payload: {
    recommendationData
  }
});
exports.setRecommendation = setRecommendation;
const unsetRecommendation = () => ({
  type: UNSET_RECOMMENDATION
});
exports.unsetRecommendation = unsetRecommendation;
const goBackToQuestionnaire = () => ({
  type: GO_BACK_TO_QUESTIONNAIRE
});
exports.goBackToQuestionnaire = goBackToQuestionnaire;
const goBackToCurrentQuestion = () => ({
  type: GO_BACK_TO_CURRENT_QUESTION
});
exports.goBackToCurrentQuestion = goBackToCurrentQuestion;
const goToUpsellPage = () => ({
  type: GO_TO_UPSELL_PAGE
});
exports.goToUpsellPage = goToUpsellPage;
const goToComparisonPage = () => ({
  type: GO_TO_COMPARISON_PAGE
});
exports.goToComparisonPage = goToComparisonPage;
const updateSelectedHandset = productId => ({
  type: UPDATE_SELECTED_HANDSET,
  payload: {
    productId
  }
});
exports.updateSelectedHandset = updateSelectedHandset;
const updateSelectedPlan = productId => ({
  type: UPDATE_SELECTED_PLAN,
  payload: {
    productId
  }
});
exports.updateSelectedPlan = updateSelectedPlan;
const updateSelectedBroadband = productId => ({
  type: UPDATE_SELECTED_BROADBAND,
  payload: {
    productId
  }
});
exports.updateSelectedBroadband = updateSelectedBroadband;
const updateSelectedBusinessSolution = productId => ({
  type: UPDATE_SELECTED_BUSINESS_SOLUTION,
  payload: {
    productId
  }
});
exports.updateSelectedBusinessSolution = updateSelectedBusinessSolution;
const updateSelectedVariant = (productId, variantId) => ({
  type: UPDATE_SELECTED_VARIANT,
  payload: {
    productId,
    variantId
  }
});
exports.updateSelectedVariant = updateSelectedVariant;
const updateSelectedRelationshipProduct = offering => ({
  type: UPDATE_SELECTED_RELATIONSHIP_PRODUCT,
  payload: {
    offering
  }
});
exports.updateSelectedRelationshipProduct = updateSelectedRelationshipProduct;
const setRecommendationSteps = steps => ({
  type: SET_STEPS,
  payload: {
    steps
  }
});
exports.setRecommendationSteps = setRecommendationSteps;
const setRecommendationStep = step => ({
  type: SET_STEP,
  payload: {
    step
  }
});
exports.setRecommendationStep = setRecommendationStep;
const goToNextStep = () => ({
  type: GO_TO_NEXT_STEP
});
exports.goToNextStep = goToNextStep;
const goToPreviousStep = () => ({
  type: GO_TO_PREVIOUS_STEP
});
exports.goToPreviousStep = goToPreviousStep;
const setAdditionalPlans = additionalPlans => ({
  type: SET_ADDITIONAL_PLANS,
  payload: {
    additionalPlans
  }
});
exports.setAdditionalPlans = setAdditionalPlans;
const setPricesCosts = costs => ({
  type: SET_PRICES_COSTS,
  payload: {
    costs
  }
});
exports.setPricesCosts = setPricesCosts;
const setAreRecommendationSpecsVisible = areRecommendationSpecsVisible => ({
  type: SET_ARE_RECOMMENDATION_SPECS_VISIBLE,
  payload: {
    areRecommendationSpecsVisible
  }
});
exports.setAreRecommendationSpecsVisible = setAreRecommendationSpecsVisible;
const reopenRecommendation = () => ({
  type: REOPEN_RECOMMENDATION
});
exports.reopenRecommendation = reopenRecommendation;
const setRecommendationTags = () => ({
  type: SET_RECOMMENDATION_TAGS
});
exports.setRecommendationTags = setRecommendationTags;
const showPlanRecommendation = () => ({
  type: SHOW_PLAN_RECOMMENDATION
});
exports.showPlanRecommendation = showPlanRecommendation;
const setIsAddonSelected = isAddonSelected => ({
  type: SET_IS_ADDON_SELECTED,
  payload: {
    isAddonSelected
  }
});
exports.setIsAddonSelected = setIsAddonSelected;
const setRating = ratingData => ({
  type: SET_RATING,
  payload: {
    ratingData
  }
});
exports.setRating = setRating;
const saveRating = () => ({
  type: SAVE_RATING
});
exports.saveRating = saveRating;
const clearRating = () => ({
  type: CLEAR_RATING
});
exports.clearRating = clearRating;